import { getQuery, luaScript } from '../helpers/helper_store';
const state = {
	serversArray: [],
	appsArray: [],
	rolesArray: [],
	currentServer: null
};

const mutations = {
	setServersArray: (state, data) => (state.serversArray = Array.isArray(data) ? data : [ data ]),
	setAppsArray: (state, data) => (state.appsArray = Array.isArray(data) ? data : [ data ]),
	setRolesArray: (state, data) => (state.rolesArray = Array.isArray(data) ? data : [ data ]),
	setCurrentServer: (state, id) => (state.currentServer = id)
};

const actions = {
	getServers({ commit, rootState }, specialUser = false) {
		// console.log("servers: ", specialUser);
		// let query = "getServerList";
		// if(specialUser) query = "getServerListByRole"
		let queryFunction;
		if(specialUser) queryFunction = getQuery("getServerListByRole", [rootState.login.user.roleid], rootState.login);
		else queryFunction = getQuery('getServerList', null, rootState.login);
		return new Promise((resolve, reject) => {
			// getQuery('getServerList', null, rootState.login)
			queryFunction
			.then((result) => {
				if(specialUser && result.length === 0){
					reject("Access denied");
				}
				commit('setServersArray', result);
				resolve();
			})
			.catch((err) => {
				reject(err);
			});
		});
	},
	getApps({ commit, rootState }, {serverSelected, specialUser = false}) {
		// console.log("apps: ", specialUser);
		let queryFunction;
		if(specialUser) queryFunction = getQuery("getSectionsByRole", [serverSelected, rootState.login.user.roleid], rootState.login);
		else queryFunction = getQuery('getSections', [serverSelected], rootState.login);
		return new Promise((resolve, reject) => {
			queryFunction
			.then((result) => {
					// console.log(result);
					commit('setAppsArray', result);
					resolve();
				})
				.catch(() => {
					reject();
				});
		});
	},
	getRoles({ rootState, commit }) {
		return new Promise((resolve, reject) => {
			//console.log('in getRoles', rootState.user);
			let query = 'getRoleList';
			//console.log(rootState);
			getQuery(query, null, rootState.login)
				.then((result) => {
					// //console.log(result);
					commit('setRolesArray', result);
					resolve();
				})
				.catch(() => {
					reject();
				});
		});
	},
	backupBase({ rootState }) {
		return new Promise((resolve, reject) => {
			luaScript('backupDB', 'backupDB', null, rootState.login)
				.then(() => {
					resolve();
				})
				.catch(() => {
					reject();
				});
		});
	}
};

const getters = {
	getServersArray: (state) => state.serversArray,
	getAppsArray: (state) => state.appsArray,
	getRolesArray: (state) => state.rolesArray
};

export default {
	state,
	mutations,
	actions,
	getters
};
